// CSRF helpers — W1 stub. Reads cookie value; W2 will integrate
// double-submit validation per backend ADR-0008.
//
// W39.78. The fallback below used to be `"_csrf"`, and so did `.env.example`.
// The backend's own default (`app/config.py::csrf_cookie_name`) is `heshe_csrf`
// and only `frontend/.env` had the right one — so a deployment configured by
// copying `.env.example` would find no CSRF cookie, send no `X-CSRF-Token`
// header, and get `403 AUTH_CSRF_FAILED` on **every** POST / PATCH / DELETE.
// Reads would keep working, which is what makes it the kind of bug that reaches
// production looking fine.
//
// The default is the backend's value, and `csrf-cookie-name.test.ts` fails if
// these two ever disagree again.

const COOKIE_NAME = import.meta.env.VITE_CSRF_COOKIE_NAME ?? "heshe_csrf";

/**
 * Read CSRF token from cookie.
 * Returns null when cookie absent (e.g. SSR or pre-auth state).
 */
export function getCsrfToken(): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.split("; ").find((row) => row.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  const value = match.slice(COOKIE_NAME.length + 1);
  return decodeURIComponent(value);
}
